import React from "react";
import {
  Card,
  Row,
  Col,
  Form,
  FormInput,
  Nav,
  NavItem,
  NavLink,
  Button,
  Alert,
  FormGroup,
} from "../../components/ui";
import { Navigate } from "react-router-dom";
import { withRouter } from "../../hooks/withRouter";
import classnames from "classnames";
import LoadingOverlay from "../common/LoadingOverlay";
import {
  registerUser,
  getAllEnabledProducts,
  getInvoiceState,
  validateCoupon,
  getSubscriptionStatus,
  loginUser,
} from "../../api";
import { handleApiError } from "../../utils/apiErrorHandler";
import MaskedInput from "react-text-mask";
import NFTPage from "../../views/NFTPage";

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      session: null,
      user: null,
      username: "",
      password: "",
      displayName: "",
      toggleTab: 1,
      loading: false,
      activeTab: "cc",
      showError: false,
      showCouponError: false,
      errorText: "",
      products: [],
      gotoPrices: false,
      btcPaymentUrl: null,
      formSubmitBtnDisabled: false,
      ownerId: "",
      checked: false,
    };
  }

  componentDidMount = async () => {
    const { location } = this.props;
    const products = await getAllEnabledProducts();
    if (
      location.pathname.includes("NFT") ||
      location.pathname.includes("nft")
    ) {
      products.data.push({
        id: 5,
        name: "Lifetime",
        cost: 2997,
        billingCycle: 65535,
        maxActiveSubscriptions: null,
        maxQuestionsPerAskerPerCycle: null,
        order: 5,
        link: null,
        marketingPhrase:
          "One time purchase - lifetime access. Bitcoin Payment Only!",
        description:
          "Lifetime membership to Bitcoin Live.  One time purchase - lifetime access. \nBitcoin Payment Only Accepted!",
        capIds: "1,2,5",
        specificPublisherIds: null,
      });
    }
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const planId = parseInt(params.get("planId"));
    const couponFromUrl = params.get("coupon");
    if (
      isNaN(planId) &&
      !this.props.planId &&
      !location.pathname.includes("NFT") &&
      !location.pathname.includes("nft")
    ) {
      this.setState({
        gotoPrices: true,
      });
    }
    this.setState({
      planId:
        location.pathname.includes("NFT") || location.pathname.includes("nft")
          ? 5
          : this.props.planId
          ? this.props.planId
          : planId,
      products: products.data,
    });
    window.scrollTo(0, 0);
    if (this.props.coupon || couponFromUrl) {
      this.setState(
        {
          coupon: couponFromUrl || this.props.coupon,
        },
        () => {
          this.applyCoupon();
        }
      );
    }
  };

  changeUsername = (event) => {
    this.setState({
      username: event.target.value,
    });
  };

  changePassword = (event) => {
    this.setState({
      password: event.target.value,
    });
  };

  changeDisplayName = (event) => {
    this.setState({
      displayName: event.target.value,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  register = async () => {
    this.setState({
      showError: false,
      formSubmitBtnDisabled: true,
    });
    const paymentMethod = this.state.activeTab === "cc" ? 1 : 2;
    const data = {
      name: this.state.displayName,
      email: this.state.username,
      password: this.state.password,
      productId: this.state.planId,
      paymentMethodId: !this.getQueryParams() ? paymentMethod : 5,
    };
    if (this.getQueryParams()) {
      const nftDetails = {
        walletAddress: this.state.ownerId,
      };
      data["nftDetails"] = nftDetails;
    }
    if (paymentMethod === 1 && !this.getQueryParams()) {
      const cc = {
        number: this.state.ccNumber.replace(/\s+/g, ""),
        expirationDate: `20${
          this.state.ccExpiration && this.state.ccExpiration.slice(3, 5)
        }-${this.state.ccExpiration && this.state.ccExpiration.slice(0, 2)}`,
        cvc: this.state.ccCVV,
      };
      data["creditCard"] = cc;
    }
    if (this.state.discount) {
      data["couponName"] = this.state.coupon;
    }
    let affiliate = localStorage.getItem("aid");
    if (affiliate !== null && affiliate !== "null") {
      data["inviterAffiliateKey"] = affiliate;
    }
    const userResp = await registerUser(data);
    if (userResp && userResp.status >= 200 && userResp.status < 300) {
      if (paymentMethod === 1 || this.getQueryParams()) {
        if (userResp) {
          const getUrl = await getInvoiceState(userResp.data.paymentKey);
          if (getUrl.data.redirectUrl) {
            this.setState({
              btcPaymentUrl: getUrl.data.redirectUrl
                ? getUrl.data.redirectUrl
                : null,
            });
          } else {
            this.setState({ loading: true });
          }
          setTimeout(() => {
            const size = document.body.scrollHeight - 150;
            window.scrollTo(0, size);
          }, 1500);
          const intervalId = setInterval(async () => {
            const invoiceStatus = await getInvoiceState(
              userResp.data.paymentKey
            );
            if (invoiceStatus && invoiceStatus.data.paymentStatusId === 5) {
              this.setState({ loading: false, btcPaymentUrl: null });
              const newData = {
                email: this.state.username,
                password: this.state.password,
              };
              const res = await loginUser(newData);
              this.getProfile(res && res.data);
              clearInterval(intervalId);
            } else if (
              invoiceStatus &&
              invoiceStatus.data.paymentStatusId === 4
            ) {
              clearInterval(intervalId);
              this.setState({
                showError: true,
                errorText: invoiceStatus.data.error,
                formSubmitBtnDisabled: false,
                btcPaymentUrl: null,
                loading: false,
              });
            }
          }, 3000);
        } else {
          this.setState({
            formSubmitBtnDisabled: false,
            loading: false,
          });
          const newData = {
            email: this.state.username,
            password: this.state.password,
          };
          const res = await loginUser(newData);
          this.getProfile(res && res.data);
        }
      } else if (paymentMethod === 2 && !this.getQueryParams()) {
        const getUrl = await getInvoiceState(userResp.data.paymentKey);
        this.setState({
          btcPaymentUrl: getUrl.data.redirectUrl,
        });
        setTimeout(() => {
          const size = document.body.scrollHeight - 150;
          window.scrollTo(0, size);
        }, 1500);
        const intervalId = setInterval(async () => {
          const invoiceStatus = await getInvoiceState(userResp.data.paymentKey);
          if (invoiceStatus && invoiceStatus.data.paymentStatusId === 5) {
            this.setState({ btcPaymentUrl: null });
            const newData = {
              email: this.state.username,
              password: this.state.password,
            };
            const res = await loginUser(newData);
            this.getProfile(res && res.data);
            clearInterval(intervalId);
          } else if (
            invoiceStatus &&
            invoiceStatus.data.paymentStatusId === 4
          ) {
            clearInterval(intervalId);
            this.setState({
              showError: true,
              errorText: "Failed",
              formSubmitBtnDisabled: false,
              btcPaymentUrl: null,
            });
          }
        }, 3000);
      }
    } else {
      const errorResponse = handleApiError(userResp, "Registration failed");
      this.setState({
        showError: true,
        errorText: errorResponse.message,
        formSubmitBtnDisabled: false,
      });
    }
  };

  registerRedirect = async (session) => {
    const paymentMethod = this.state.activeTab === "cc" ? 1 : 2;
    const userData = {
      name: this.state.displayName,
      email: this.state.username,
      password: this.state.password,
      productId: this.state.planId,
      paymentMethodId: !this.getQueryParams() ? paymentMethod : 5,
    };
    const subscriptionStatus = await getSubscriptionStatus(session.userId);
    this.props.navigate("/blogs/premium/", {
      state: {
        details: userData,
        products: this.state.products,
        renewal:
          subscriptionStatus &&
          subscriptionStatus.data[0].subscription.nextRenewal.date,
      },
    });
  };
  getProfile = async (session) => {
    fetch(process.env.REACT_APP_API_URL + "user/" + session.userId, {
      headers: {
        "Content-Type": "application/json",
        "X-Auth-Token": session.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("session", JSON.stringify(session.token));
        this.registerRedirect(session);
        this.setState({
          authenticated: true,
          user: data,
        });
      });
  };

  applyCoupon = async () => {
    let data = {
      couponName: this.state.coupon,
      productIds: [this.state.planId],
    };
    if (this.state.coupon) {
      const resp = await validateCoupon(data);
      if (resp.data) {
        resp.data.map((item) => {
          if (item.applicable) {
            this.setState({
              showCouponError: false,
              discount: item.discountedCost,
            });
          } else {
            this.setState({
              showCouponError: true,
              couponError: item.reason,
            });
          }
        });
      }
    }
  };
  getQueryParams() {
    const { location } = this.props;
    if (
      location.pathname.includes("NFT") ||
      location.pathname.includes("nft")
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    // Handle redirects using Navigate
    if (this.state.registrationComplete) {
      return <Navigate to="/success" replace />;
    }
    if (this.state.gotoPrices) {
      return <Navigate to="/prices" replace />;
    }

    return (
      <LoadingOverlay active={this.state.loading} spinner text="Processing...">
        <Col sm={this.props.planId ? {} : { size: 6, offset: 3 }}>
          <Card small className="mb-4 p-4">
            <Row>
              <Col>
                <Form>
                  <h6 style={{ color: "#FAA713" }}>General Information</h6>
                  <br />
                  <Row>
                    <Col lg={{ size: 12 }}>
                      <FormGroup className="form-group">
                        <label htmlFor="feCurrPass">Display Name</label>
                        <FormInput
                          id="feCurrPass"
                          type="text"
                          placeholder="Display Name"
                          value={this.state.displayName}
                          onChange={this.changeDisplayName}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={{ size: 6 }}>
                      <FormGroup className="form-group">
                        <label htmlFor="feCurrPass">Email</label>
                        <FormInput
                          id="feCurrPass"
                          type="text"
                          placeholder="Email"
                          value={this.state.username}
                          onChange={this.changeUsername}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={{ size: 6 }}>
                      <FormGroup className="form-group">
                        <label htmlFor="feCurrPass">Password</label>
                        <FormInput
                          id="feNewPass"
                          type="password"
                          placeholder="Password"
                          value={this.state.password}
                          onChange={this.changePassword}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ paddingTop: 20 }} lg={{ size: 12 }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                          marginBottom: 0,
                        }}
                      >
                        <div
                          onClick={() => {
                            this.setState({
                              checked: !this.state.checked,
                            });
                          }}
                          style={{
                            width: "15px",
                            height: "15px",
                            border: "2px solid #FAA713",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          {this.state.checked && (
                            <div
                              style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: "#FAA713",
                                borderRadius: "50%",
                              }}
                            />
                          )}
                        </div>
                        I Accept the{" "}
                        <a
                          href="https://bitcoin.live/terms&conditions"
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            color: "#FAA713",
                          }}
                        >
                          Terms and Conditions
                        </a>
                      </label>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={{ size: 6 }}>
                      <FormGroup>
                        <br />
                        <br />
                        <h6 style={{ color: "#FAA713" }}>Plan Information</h6>
                        <h4>
                          {this.state.planId &&
                            this.state.products.filter(
                              (p) => p.id === this.state.planId
                            )[0].name}
                          {!this.getQueryParams() && (
                            <b>
                              {" - "}
                              <span
                                className={this.state.discount && "discount"}
                              >
                                $
                                {this.state.planId &&
                                  this.state.products.filter(
                                    (p) => p.id === this.state.planId
                                  )[0].cost}
                              </span>{" "}
                              {this.state.discount && (
                                <span> ${this.state.discount}</span>
                              )}
                            </b>
                          )}
                        </h4>
                        <br />
                        {this.state.planId && (
                          <div>
                            <b>
                              {
                                this.state.products.filter(
                                  (p) => p.id === this.state.planId
                                )[0].description
                              }
                            </b>
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col
                      lg={{ size: 6 }}
                      className="d-flex justify-content-center"
                    >
                      <FormGroup>
                        <br />
                        <br />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="3" md="12">
                      {!this.getQueryParams() && (
                        <FormGroup>
                          <br />
                          <br />
                          <FormGroup className="form-group">
                            <label htmlFor="feCurrPass">Enter Coupon</label>
                            <FormInput
                              type="text"
                              placeholder="Coupon"
                              value={this.state.coupon}
                              onChange={(text) =>
                                this.setState({ coupon: text.target.value })
                              }
                            />
                            <Button
                              style={{ marginTop: 10 }}
                              theme="accent"
                              size="sm"
                              className="btn-orange"
                              onClick={this.applyCoupon}
                            >
                              Apply
                            </Button>
                            {this.state.showCouponError && (
                              <Alert className="mb-0">
                                <i className="fa fa-error mx-2"></i>
                                {this.state.couponError}
                              </Alert>
                            )}
                          </FormGroup>
                        </FormGroup>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={{ size: 12 }}>
                      <FormGroup>
                        <br />
                        <br />
                        <h6 style={{ color: "#FAA713" }}>
                          Payment Information
                        </h6>
                        <Nav tabs>
                          {this.getQueryParams() && (
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.getQueryParams(),
                                })}
                              >
                                NFT
                              </NavLink>
                            </NavItem>
                          )}
                          {!this.getQueryParams() && (
                            <>
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: this.state.activeTab === "cc",
                                  })}
                                  onClick={() => {
                                    this.toggleTab("cc");
                                  }}
                                >
                                  Credit Card
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: this.state.activeTab === "bitcoin",
                                  })}
                                  onClick={() => {
                                    this.toggleTab("bitcoin");
                                  }}
                                >
                                  Bitcoin
                                </NavLink>
                              </NavItem>
                            </>
                          )}
                        </Nav>
                      </FormGroup>
                    </Col>
                  </Row>
                  <br />
                  {this.getQueryParams() && (
                    <NFTPage
                      setownerId={(value) => {
                        this.setState({ ownerId: value });
                      }}
                    />
                  )}
                  {this.state.activeTab === "cc" && !this.getQueryParams() && (
                    <Row>
                      <Col lg={{ size: 6 }}>
                        <FormGroup className="form-group">
                          <label htmlFor="feCurrPass">Card Holders Name</label>
                          <FormInput
                            type="text"
                            placeholder="Enter name"
                            value={this.state.ccName}
                            onChange={(text) =>
                              this.setState({ ccName: text.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={{ size: 6 }}>
                        <FormGroup className="form-group">
                          <label htmlFor="feCurrPass">Card Number</label>
                          <MaskedInput
                            mask={[
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              " ",
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              " ",
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              " ",
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                              /[0-9]/,
                            ]}
                            className="form-control"
                            placeholder="0000 0000 0000 00000"
                            guide={false}
                            value={this.state.ccNumber}
                            onChange={(text) =>
                              this.setState({ ccNumber: text.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={{ size: 6 }}>
                        <FormGroup className="form-group">
                          <label htmlFor="feCurrPass">Expiration Date</label>
                          <MaskedInput
                            mask={[/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/]}
                            className="form-control"
                            placeholder="MM/YY"
                            guide={false}
                            value={this.state.ccExpiration}
                            onChange={(text) =>
                              this.setState({
                                ccExpiration: text.target.value,
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={{ size: 6 }}>
                        <FormGroup className="form-group">
                          <label htmlFor="feCurrPass">CVC</label>
                          <MaskedInput
                            mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
                            className="form-control"
                            placeholder="000"
                            guide={false}
                            value={this.state.ccCVV}
                            onChange={(text) =>
                              this.setState({ ccCVV: text.target.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      {this.state.activeTab === "cc" &&
                        this.state.btcPaymentUrl !== null && (
                          <iframe
                            src={this.state.btcPaymentUrl}
                            style={{
                              height: 750,
                              width: "100%",
                              border: "none",
                            }}
                          ></iframe>
                        )}
                    </Row>
                  )}
                  {this.state.activeTab === "bitcoin" && (
                    <Row>
                      <Col lg="12">
                        <p className="billing-title">
                          <img
                            className="mr-1"
                            style={{ maxWidth: "100px" }}
                            src={require("../../images/bitcoin-live/bitcoin_PNG36.png")}
                            alt="Bitcoin Live"
                          />
                        </p>
                        {this.state.btcPaymentUrl === null && (
                          <div>
                            Your invoice will be generated after you complete
                            the payment.
                          </div>
                        )}
                        {this.state.btcPaymentUrl !== null && (
                          <div>
                            <iframe
                              src={this.state.btcPaymentUrl}
                              style={{
                                height: 750,
                                width: "100%",
                                border: "none",
                              }}
                            ></iframe>
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                  <Button
                    theme="accent"
                    disabled={
                      this.state.formSubmitBtnDisabled ||
                      this.state.displayName === "" ||
                      this.state.username === "" ||
                      this.state.password === "" ||
                      !this.state.checked ||
                      (this.getQueryParams() && this.state.ownerId === "")
                    }
                    className="btn-gradient mt-4 w100"
                    onClick={this.register}
                  >
                    Complete your order
                  </Button>
                </Form>
                <br />
                {this.state.showError && (
                  <Alert className="mb-0">
                    <i className="fa fa-error mx-2"></i>
                    {this.state.errorText}
                  </Alert>
                )}
              </Col>
            </Row>
          </Card>
        </Col>
      </LoadingOverlay>
    );
  }
}

export default withRouter(RegisterForm);
